module.exports = __webpack_public_path__ + "img/artillery-turret-base.45d4628a.png";